/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import 'underscore';
import userData from './user-data';
import { toLocalizedRiotUrl } from './../utils/language';

var initData = window.sellingGlobalData || {};
var defaultDrafts = initData.defaultDrafts;

function postJson(url, draft) {
    return $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: url,
        data: JSON.stringify(draft),
        dataType: 'json'
    });
}

function resetUnwantedProperties(draft) {
    draft.itemId = 0;
}

function isNullOrUndefined(val) {
    return _.isNull(val) || _.isUndefined(val);
}

function getType(draft) {
    var hasOpeningPrice = !isNullOrUndefined(draft.openingBid);
    var hasFixedPrice = !isNullOrUndefined(draft.fixedPrice);
    if (hasOpeningPrice && !hasFixedPrice) {
        return 'Auction';
    }

    if (hasOpeningPrice && hasFixedPrice) {
        return 'AuctionBin';
    }

    if (!hasOpeningPrice && hasFixedPrice) {
        return 'PureBin';
    }

    return 'Unknown';
}

function ensureApplicationId(draft) {
    if (!draft.metadata) {
        draft.metadata = {};
    }
    draft.metadata.applicationId = 'SYI-Riot';
}

function ensureBraintree(draft) {
    if (
        userData.braintree.isBraintreeOnly &&
        draft.paymentOptions.length == 0
    ) {
        draft.paymentOptions.push('Braintree');
    }
}

const isPureBin = function(draft) {
    return draft && getType(draft) === 'PureBin';
};

const isAuctionBin = function(draft) {
    return draft && getType(draft) === 'AuctionBin';
};

const getDefaultTemplateValue = function(propertyName) {
    return defaultDrafts.newTemplate[propertyName];
};

const loadDraft = function(draftId) {
    var deferred = $.Deferred();

    if (!draftId) {
        deferred.reject();
    } else {
        $.get(toLocalizedRiotUrl('/selling/api/drafts/' + draftId))
            .then(function(data) {
                deferred.resolve(data.draft);
            })
            .fail(function(result) {
                deferred.reject(result);
            });
    }

    return deferred.promise();
};

const loadDrafts = function() {
    var deferred = $.Deferred();

    $.get(toLocalizedRiotUrl('/selling/api/drafts/'))
        .then(function(data) {
            deferred.resolve(data.items);
        })
        .fail(function(result) {
            deferred.reject(result);
        });

    return deferred.promise();
};

const loadDefaultDraft = function() {
    return _.clone(defaultDrafts.newItem);
};

const loadDefaultTemplateDraft = function() {
    return _.clone(defaultDrafts.newTemplate);
};

const loadDraftFromTemplate = function(templateId) {
    var deferred = $.Deferred();

    postJson(toLocalizedRiotUrl('/selling/api/drafts/from-template'), {
        templateId: templateId
    })
        .success(function(data) {
            let draft = data.draft;
            resetUnwantedProperties(draft);
            draft.draftReason = 'Template';
            deferred.resolve(draft);
        })
        .error(function() {
            deferred.reject('Could not load the draft from the template');
        });

    return deferred.promise();
};

const saveDraft = function(draft) {
    var deferred = $.Deferred();
    if (draft.draftReason === 'Template') {
        // Drafts for Templates cannot be saved
        deferred.reject('Cannot save Template draft');
        return deferred.promise();
    }

    ensureApplicationId(draft);
    ensureBraintree(draft);

    postJson(toLocalizedRiotUrl('/selling/api/drafts'), draft)
        .success(data => {
            if (data.errorCode) {
                deferred.reject(data);
            } else if (data.draftId) {
                deferred.resolve(data);
            } else {
                deferred.reject(data);
            }
        })
        .error(result => {
            deferred.reject(result);
        });
    return deferred.promise();
};

const resolveImages = syiSlice => {
    var slots = syiSlice.images.slots;
    var images = [];
    for (var i = 0; i < slots.length; i++) {
        var slot = slots[i];
        if (slot.imageId == null) {
            continue;
        }
        if (slot.isListingImage) {
            images.push({
                draftImage: null,
                listingImage: {
                    imageId: slot.imageId,
                    rotationDegrees: slot.rotationDegrees,
                    filename: slot.filename,
                    imageGroupId: slot.imageGroupId
                },
                imageUrl: slot.imageUrl
            });
        } else {
            images.push({
                draftImage: {
                    imageId: slot.imageId,
                    rotationDegrees: slot.rotationDegrees
                },
                listingImage: null,
                imageUrl: slot.imageUrl
            });
        }
    }
    return images;
};

const getCustomEndTime = itemDuration => {
    if (
        !_.isString(itemDuration.customEndTimeHour) ||
        !_.isString(itemDuration.customEndTimeMinute)
    ) {
        return null;
    }

    return (
        itemDuration.customEndTimeHour + ':' + itemDuration.customEndTimeMinute
    );
};

const buildDraftFromState = syiSlice => {
    var draft = {};
    draft.draftId = syiSlice.draft.draftId;
    draft.draftReason = syiSlice.draft.draftReason;
    draft.MemberId = syiSlice.draft.memberId;
    draft.itemId = syiSlice.draft.itemId;
    draft.restart = syiSlice.draft.restart;
    draft.publishedPromoted = syiSlice.draft.publishedPromoted;
    draft.publishedHighlighted = syiSlice.draft.publishedHighlighted;
    draft.createdDate = syiSlice.draft.createdDate;
    draft.lastModifiedDate = syiSlice.draft.lastModifiedDate;
    draft.publishedDate = syiSlice.draft.publishedDate;
    draft.publishedAsItemType = syiSlice.draft.publishedAsItemType;
    draft.reference = syiSlice.draft.reference;
    draft.additionalDescriptions = syiSlice.draft.additionalDescriptions; //TODO
    draft.metadata = syiSlice.draft.metadata;
    if (syiSlice.draft.templateId) {
        draft.templateId = syiSlice.draft.templateId;
    }
    if (syiSlice.draft.templateName) {
        draft.templateName = syiSlice.draft.templateName;
    }

    draft.shortDescription = syiSlice.shortDescription.shortDescription;
    draft.longDescription = syiSlice.longDescription.longDescription;
    draft.categoryId = syiSlice.category.draftCategoryId;
    // categoryPath is needed on frontend for when cancelling edit of property.
    draft.categoryPath = syiSlice.category.draftCategoryPath;
    draft.images = resolveImages(syiSlice);
    draft.openingBid = syiSlice.price.openingBid;
    draft.reservePrice = syiSlice.price.reservePrice;
    draft.fixedPrice = syiSlice.price.isPureBinSelected
        ? syiSlice.price.fixedPrice
        : syiSlice.price.auctionBinPrice;
    draft.vat = syiSlice.price.vat;

    draft.durationDays = syiSlice.itemDuration.durationDays;
    draft.customEndTime = getCustomEndTime(syiSlice.itemDuration);
    draft.shippingOptions = syiSlice.shipping.selectedShippingOptions;
    draft.paymentOptions = syiSlice.payment.selectedPaymentOptions;

    draft.itemCondition = syiSlice.itemCondition.itemCondition;
    draft.allowedBuyerRegion = syiSlice.buyerRegion.selectedBuyerRegion;

    draft.campaignCode = syiSlice.campaignCode.campaignCode;
    draft.campaignCodeId = syiSlice.campaignCode.campaignCodeId;

    draft.displayPromoted = syiSlice.extraFeatures.displayPromoted;
    draft.displayHighlighted = syiSlice.extraFeatures.displayHighlighted;

    draft.charityId = syiSlice.charity.charityId;
    draft.allowZeroDayAuctions = syiSlice.charity.allowZeroDayAuctions;
    draft.version = syiSlice.draft.version;

    draft.attributeValues = {
        termAttributeValues: syiSlice.attributes.categoryAttributes.map(
            attribute => {
                const values = attribute.options.reduce((acc, option) => {
                    if (option.isActive) {
                        acc.push(option.value);
                    }
                    return acc;
                }, []);
                return {
                    id: attribute.id,
                    backingField: attribute.backingField,
                    userGenerated: true,
                    values
                };
            }
        )
    };

    return draft;
};

const deleteDraft = function(draftId) {
    return deleteDrafts([draftId]);
};

const deleteDrafts = function(draftIds) {
    var deferred = $.Deferred();

    $.post(toLocalizedRiotUrl('/selling/api/drafts/delete'), {
        draftIds: draftIds
    })
        .done(function() {
            deferred.resolve();
        })
        .fail(function() {
            deferred.reject('Could not delete the draft');
        });

    return deferred.promise();
};

export default {
    isPureBin,
    isAuctionBin,
    getDefaultTemplateValue,
    loadDraft,
    loadDrafts,
    loadDefaultDraft,
    loadDefaultTemplateDraft,
    loadDraftFromTemplate,
    saveDraft,
    buildDraftFromState,
    deleteDraft,
    deleteDrafts,
    getCustomEndTime
};
